import { auth, firestore, storage } from "../../firebase"
import { SET_LOADING, RESET_LOADING, AUTH_ERROR, REGISTER } from "../types"
import { User, UserData } from "../../models/user"
import { Dispatch } from "redux"

export const register = (user: User) => async (dispatch: Dispatch) => {
  //   const { auth } = firebase
  let taken
  dispatch({
    type: SET_LOADING,
  })
  try {
    const {
      email,
      password,
      username,
      firstName,
      lastName,
      location,
      bio,
      accountType,
    } = user
    let acc = await firestore.collection("users").get()
    acc.forEach((doc) => {
      if (doc.data().username.toLowerCase() === username.toLowerCase()) {
        taken = "Username already taken"
      }
    })
    if (taken) {
      dispatch({ type: RESET_LOADING })
      return taken
    }

    let response = await auth.createUserWithEmailAndPassword(
      email,
      password ? password : ""
    )
    await firestore.collection("users").doc(response?.user?.uid).set({
      username: username.toLowerCase(),
      email: email.toLowerCase(),
      firstName,
      lastName,
      location,
      bio,
      accountType,
      website: "",
      fans: [],
    })
    let usr: User = {
      pimage: "",
      accountType: accountType,
      bio: bio,
      email: email,
      fans: [],
      firstName: firstName,
      lastName: lastName,
      location: location,
      id: response.user?.uid ? response.user?.uid : "",
      username: username.toLowerCase(),
      website: "",
    }
    dispatch({ type: REGISTER, payload: usr })
    dispatch({ type: RESET_LOADING })
  } catch (error) {
    dispatch({ type: AUTH_ERROR })
    dispatch({ type: RESET_LOADING })
    return error.message
  }
}

export const login = (cred: LoginCred) => async (dispatch: Dispatch) => {
  dispatch({
    type: SET_LOADING,
  })
  try {
    const { email, password } = cred
    const response = await auth.signInWithEmailAndPassword(
      email.toLowerCase(),
      password
    )
    dispatch({ type: REGISTER, payload: response.user })
    dispatch({
      type: RESET_LOADING,
    })
  } catch (err) {
    dispatch({ type: AUTH_ERROR })
    dispatch({
      type: RESET_LOADING,
    })
    return err.message
  }
}

export const logout = () => async (dispatch: Dispatch) => {
  try {
    await auth.signOut()
    dispatch({
      type: AUTH_ERROR,
    })
  } catch (error) {
    console.log(error.message)
  }
}

export const updateUser = (user: UserData) => async (dispatch: Dispatch) => {
  dispatch({ type: SET_LOADING })
  try {
    if (user) {
      const {
        accountType,
        bio,
        firstName,
        lastName,
        img,
        location,
        website,
        id,
        imgFile,
      } = user
      if (imgFile) {
        await storage.ref(`profiles/${id}`).put(imgFile)
      }

      await firestore.collection("users").doc(user.id).update({
        accountType,
        bio,
        firstName,
        lastName,
        img,
        location,
        website,
      })
    } else {
      const {
        account_type,
        bio,
        firstName,
        lastName,
        location,
        website,
        id,
      } = user
      await firestore.collection("users").doc(id).update({
        account_type,
        bio,
        firstName,
        lastName,
        location,
        website,
      })
    }
  } catch (error) {
    console.log(error.message)
  }
  dispatch({ type: RESET_LOADING })
}
